package com.shadowings.gero.data.lessons.chapter12

import com.shadowings.gero.data.lessons.inlineMeaning
import com.shadowings.gero.data.lessons.buildVocabQuizContent
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_vocab_oggetti_sacri_alyn_1
import gero.composeapp.generated.resources.exp_content_vocab_oggetti_sacri_zeta_1
import gero.composeapp.generated.resources.exp_content_vocab_oggetti_sacri_zeta_2
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_word_name
import gero.composeapp.generated.resources.lesson_vocab_oggetti_sacri_title

fun getVocabOggettiSacriContent(words: List<Word>, languageCode: String): List<IExplanation> {
    val intro = listOf(
        ExplanationContent(
            title = Res.string.lesson_vocab_oggetti_sacri_title,
            content = Res.string.exp_content_vocab_oggetti_sacri_zeta_1,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.lesson_vocab_oggetti_sacri_title,
            content = Res.string.exp_content_vocab_oggetti_sacri_alyn_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.lesson_vocab_oggetti_sacri_title,
            content = Res.string.exp_content_vocab_oggetti_sacri_zeta_2,
            face = Faces.Sleeping,
            character = Characters.Zeta,
        ),
    )

    val slides = oggettiSacriWordIds
        .mapNotNull { id -> words.firstOrNull { it.id == id } }
        .map { word ->
            ExplanationContent(
                title = Res.string.exp_title_word_name,
                titleArgs = listOf(word.getMeaning(languageCode)),
                content = Res.string.exp_content_word_reading_and_meaning,
                contentArgs = listOf(
                    word.reading,
                    word.inlineMeaning(languageCode),
                    word.getNote(languageCode)
                ),
                face = Faces.Happy,
                character = Characters.Alyn,
                composable = { MdCWord(word.gardiner, rtl = false, cart = false, size = 96.dp) },
                wordId = word.id
            )
        }

    return intro + slides
}

private val oggettiSacriOldWordIds = listOf(
    "PANE", "ACQUA", "VINO", "GRANO", "ALBERO", "FALCO", "COBRA", "UCCELLO", "PESCE",
    "TORO", "MUCCA", "GATTO", "GATTA", "CASA", "LETTERA", "ORO", "STRADA", "CITTA",
    "CAMPO", "TEMPIO", "VIGNETO", "TOMBA", "NECROPOLI", "PALAZZO", "FIUME", "DESERTO",
    "CIELO", "NAVE", "PORTA"
)

fun getVocabOggettiSacriQuizContent(
    explanations: List<IExplanation>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val baseQuizzes = buildVocabQuizContent(
        explanations = explanations,
        words = words,
        languageCode = languageCode,
        additionalOptions = setOf("PANE", "ACQUA")
    )

    val newWords = oggettiSacriWordIds.mapNotNull { id -> words.firstOrNull { it.id == id } }
    val oldWords = oggettiSacriOldWordIds.mapNotNull { id -> words.firstOrNull { it.id == id } }

    val multiPressNew = buildMultiPress(newWords.shuffled().take(4), languageCode)
    val multiPressMixed = buildMultiPress(
        (newWords.shuffled().take(2) + oldWords.shuffled().take(2)).shuffled(),
        languageCode
    )
    val multiPressOld = buildMultiPress(oldWords.shuffled().take(4), languageCode)

    return (baseQuizzes + multiPressNew + multiPressMixed + multiPressOld).shuffled()
}
